"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restrictedByAdmin = exports.restrictedByEvents = void 0;
var tslib_1 = require("tslib");
var v2 = tslib_1.__importStar(require("./v2"));
function restrictedByEvents(group) {
    return v2.restrictedByEvents(group.settings.accessRestriction);
}
exports.restrictedByEvents = restrictedByEvents;
function restrictedByAdmin(group) {
    var _a;
    return v2.restrictedByAdmin((_a = group.settings) === null || _a === void 0 ? void 0 : _a.accessRestriction);
}
exports.restrictedByAdmin = restrictedByAdmin;
//# sourceMappingURL=index.js.map